import { FEATURE_FLAGS } from '@aibees/elephant/constants';
import { FeatureFlags, SearchMatchType } from '@aibees/elephant/types';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { isFeatureEnabled } from '@aibees/shared/feature-flags';
import { capitalize } from '@aibees/shared/utils';
import {
  Classification,
  ClassificationGroups,
  ClassificationType,
  FilterBadgeType,
  FilterCategory,
  SearchFilterBase,
  SearchFilterType,
} from '../types';
import { technologyApiResponseMapper } from '../utils';

export default function technologiesFilterConfig(): SearchFilterBase {
  const group = ClassificationGroups.COMPANY;

  return {
    name: 'Technologies',
    icon: 'laptop',
    index: 2,
    type: SearchFilterType.ROOT,
    category: [FilterCategory.COMPANY_DATA],
    pinned: true,
    badge: FilterBadgeType.BETA,
    sections: { main: 2, more: 1 },
    layer: 3,
    comingSoon: !isFeatureEnabled(
      FEATURE_FLAGS,
      FeatureFlags.FILTER_COMPANY_PEOPLE_TECHNOLOGIES
    ),
    disabled: !isFeatureEnabled(
      FEATURE_FLAGS,
      FeatureFlags.FILTER_COMPANY_PEOPLE_TECHNOLOGIES
    ),
    utils: {
      tags: {
        config: {
          showAsCard: true,
          tagsCardTitle: 'Tech. Stacks',
        },
      },
    },
    items: [
      {
        name: 'Include',
        type: SearchFilterType.CUSTOM_SELECT,
        icon: undefined,
        index: 0,
        key: 'include_technologies',
        field: 'include_technologies',
        layer: 4,
        exactMatch: {
          enabled: true,
          default: SearchMatchType.SMART,
        },
        metadata: {
          color: 'primary',
          icon: 'add-circle-outline',
          preset: 'technology',
          placeholder: 'Include Technologies ( OR ) Search',
          delimiter: '::',
          autocomplete: {
            multiple: true,
            checkboxPosition: 'left',
            allowCustomValuesByEnter: true,
          },
        },
        utils: {
          optionsApiFormatter: (data?: any[]) =>
            technologyApiResponseMapper(data),
          tags: { labelFormatter: capitalize },
        },
        searchKey: 'value',
        config: { labelKey: 'value', valueKey: 'value' },
        options: [
          {
            type: 'URL',
            value: `/elephant-management/um/classifications?size=25&page=0&group=${group}&key=${ClassificationType.TECHNOLOGY}`,
            label: '',
            icon: null,
            index: undefined,
          },
        ],
      },
      {
        name: 'Exclude',
        type: SearchFilterType.CUSTOM_SELECT,
        icon: undefined,
        index: 1,
        layer: 4,
        key: 'exclude_technologies',
        field: 'exclude_technologies',
        exactMatch: {
          enabled: true,
          default: SearchMatchType.SMART,
        },
        metadata: {
          color: 'error',
          icon: 'block',
          preset: 'technology',
          placeholder: 'Exclude Technologies ( OR ) Search',
          delimiter: '::',
          autocomplete: {
            multiple: true,
            checkboxPosition: 'left',
            allowCustomValuesByEnter: true,
          },
        },
        utils: {
          optionsApiFormatter: (data?: any[]) =>
            technologyApiResponseMapper(data),
          tags: { labelFormatter: capitalize },
        },
        searchKey: 'value',
        config: { labelKey: 'value', valueKey: 'value' },
        options: [
          {
            type: 'URL',
            value: `/elephant-management/um/classifications?size=25&page=0&group=${group}&key=${ClassificationType.TECHNOLOGY}`,
            label: '',
            icon: null,
            index: undefined,
          },
        ],
      },
      {
        name: 'Include (AND)',
        type: SearchFilterType.CUSTOM_SELECT,
        icon: undefined,
        index: 0,
        layer: 4,
        key: 'all_of_technologies',
        field: 'all_of_technologies',
        exactMatch: {
          enabled: true,
          default: SearchMatchType.SMART,
        },
        metadata: {
          color: 'warning',
          icon: 'add-task',
          preset: 'technology',
          placeholder: 'Include Technologies ( AND ) Search',
          delimiter: '::',
          autocomplete: {
            multiple: true,
            checkboxPosition: 'left',
            allowCustomValuesByEnter: true,
          },
        },
        utils: {
          optionsApiFormatter: (data?: Classification[]) =>
            technologyApiResponseMapper(data),
          tags: { labelFormatter: capitalize },
        },
        searchKey: 'value',
        config: { labelKey: 'value', valueKey: 'value' },
        options: [
          {
            type: 'URL',
            value: `/elephant-management/um/classifications?size=25&page=0&group=${group}&key=${ClassificationType.TECHNOLOGY}`,
            label: '',
            icon: null,
            index: undefined,
          },
        ],
      },
    ],
  };
}
